export default __webpack_public_path__ + "images/661c9fee6a0bb6a9efddf9e3a4d7d4d5-date-night.webp";